// extracted by mini-css-extract-plugin
export var card = "iconCardGrid-module--card--52bf6";
export var cardDescription = "iconCardGrid-module--cardDescription--2b7ce";
export var cardHeader = "iconCardGrid-module--cardHeader--20c6e";
export var cardTitle = "iconCardGrid-module--cardTitle--04825";
export var grid = "iconCardGrid-module--grid--a5807";
export var headline = "iconCardGrid-module--headline--64964";
export var icon = "iconCardGrid-module--icon--77e92";
export var iconCardGrid = "iconCardGrid-module--iconCardGrid--ba361";
export var inner = "iconCardGrid-module--inner--44c0f";